var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserNinja(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 192C59.25 192 83.75 180.5 101.25 162.25C116.25 216.25 165.25 256 224 256C294.75 256 352 198.75 352 128S294.75 0 224 0C173.625 0 130.375 29.375 109.5 71.75C92.125 47.75 64 32 32 32C32 65.375 49.125 94.75 75.125 112C49.125 129.25 32 158.625 32 192ZM176 96H272C289.75 96 304 110.25 304 128H144C144 110.25 158.25 96 176 96ZM305.795 306.941L224 416L142.205 306.941C61.357 321.625 0 392.246 0 477.332C0 496.477 15.523 512 34.664 512H413.336C432.477 512 448 496.477 448 477.332C448 392.246 386.648 321.625 305.795 306.941Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNinja);
export default __webpack_public_path__ + "static/media/user-ninja.e3f383de55c5d1b30780f6c6c9144a6c.svg";
export { ForwardRef as ReactComponent };